<div class="neq-dialog" fxLayout="column" [class.complete-advanced-search]="!singleSelectionMode" style="width: 40vw;">
  <h1>{{ 'label.user.advanced-search.sample.title' | translate }}</h1>
  <div fxLayout="column" fxLayoutGap="0.357rem">


    <ng-container *ngIf="!singleSelectionMode">
      <div fxLayout="row" fxLayoutAlign="start center">
        <advanced-sample-multiple-select fxFlex="100"
          [multiSelectInput]="businessUnitSelection"
          bindLabel="label" (update)="onSelectionRefreshed(businessUnitSelection)">
        </advanced-sample-multiple-select>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center">
        <advanced-sample-multiple-select fxFlex="100" #selectEntity
          [multiSelectInput]="entitySelection"
          bindLabel="label" (update)="onSelectionRefreshed(entitySelection)"
          [paginatedResults]="false"
        >
        </advanced-sample-multiple-select>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center">
        <advanced-sample-multiple-select fxFlex="100" #selectSupplier
          [multiSelectInput]="supplierSelection"
          bindLabel="label" (update)="onSelectionRefreshed(supplierSelection)">
        </advanced-sample-multiple-select>
      </div>
    </ng-container>


    <div class="tree-select-container" fxLayout="row" *ngIf="allLevels; else loadingLevel">
      <p-treeSelect
        [options]="allLevels"
        [(ngModel)]="allSelectedLevels"
        [placeholder]="'label.common.level' | translate"
        [filter]="true"
        [showClear]="true"
        selectionMode="checkbox"
        [emptyMessage]="'msg.common.levels.empty' | translate"
        (onNodeSelect)="onLevelSelection()"
        (onNodeUnselect)="onLevelSelection()">
      </p-treeSelect>
    </div>
    <ng-template #loadingLevel>
      <div fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="row" fxLayoutAlign="start center">
          <p-progressSpinner styleClass="inline-spinner"
          ></p-progressSpinner>
          {{'msg.common.levels.loading' | translate}}
        </div>
      </div>
    </ng-template>


    <div fxLayout="row" fxLayoutAlign="start center">
      <advanced-sample-multiple-select fxFlex="100" #selectPredictionModel
        [multiSelectInput]="predModSelection"
        bindLabel="label" (update)="onSelectionRefreshed($event)">
      </advanced-sample-multiple-select>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <advanced-sample-multiple-select fxFlex="100" #selectReference
        [multiSelectInput]="refSelection"
        bindLabel="label" (update)="onSelectionRefreshed($event)">
      </advanced-sample-multiple-select>
    </div>

    <ng-container *ngIf="!singleSelectionMode">
      <div fxLayout="row" fxLayoutAlign="start center">
        <advanced-sample-multiple-select fxFlex="100" #selectSpecies
          [multiSelectInput]="speciesSelection"
          bindLabel="label" (update)="onSelectionRefreshed($event)">
        </advanced-sample-multiple-select>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center">
        <advanced-sample-multiple-select fxFlex="100" #selectFarm
          [multiSelectInput]="farmSelection"
          bindLabel="label" (update)="onSelectionRefreshed($event)">
        </advanced-sample-multiple-select>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center">
        <advanced-sample-multiple-select fxFlex="100" #selectDistributor
          [multiSelectInput]="distributorSelection"
          bindLabel="label" (update)="onSelectionRefreshed($event)">
        </advanced-sample-multiple-select>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center">
        <advanced-sample-multiple-select fxFlex="100" #selectTechnician
          [multiSelectInput]="technicianSelection"
          bindLabel="label" (update)="onSelectionRefreshed($event)">
        </advanced-sample-multiple-select>
      </div>

      <div>
        <div style="padding-bottom: 3px;">{{ 'label.common.validation-date' | translate}}</div>
        <div style="display: flex;">
          <div class="date-picker-div">
            {{ 'label.common.date-picker.from' | translate}}
            <p-calendar
              [(ngModel)]="startValidation"
              [touchUI]="true"
              [readonlyInput]="true"
              dateFormat="{{returnDateFormat()}}"
              (onSelect)="onDateSelection()"
            ></p-calendar>
            <em *ngIf="startValidation"
              (click)="startValidation = null; onDateSelection();"
              (keyDown)="startValidation = null; onDateSelection();"
              class="reset-icon fas fa-times"
            ></em>
          </div>
          <div class="date-picker-div">
            {{ 'label.common.date-picker.to' | translate}}
            <p-calendar
              [(ngModel)]="endValidation"
              [touchUI]="true"
              [readonlyInput]="true"
              dateFormat="{{returnDateFormat()}}"
              (onSelect)="onDateSelection()"
            ></p-calendar>
            <em *ngIf="endValidation"
              (click)="endValidation = null; onDateSelection();"
              (keyDown)="endValidation = null; onDateSelection();"
              class="reset-icon fas fa-times"
            ></em>
          </div>
        </div>
      </div>

      <div>
        <div style="padding-bottom: 3px;">{{ 'label.common.reception-date' | translate}}</div>
        <div style="display: flex;">
          <div class="date-picker-div">
            {{ 'label.common.date-picker.from' | translate}}
            <p-calendar
              [(ngModel)]="startReception"
              [touchUI]="true"
              [readonlyInput]="true"
              dateFormat="{{returnDateFormat()}}"
              (onSelect)="onDateSelection()"
            ></p-calendar>
            <em *ngIf="startReception"
              (click)="startReception = null; onDateSelection();"
              (keyDown)="startReception = null; onDateSelection();"
              class="reset-icon fas fa-times"
            ></em>
          </div>
          <div class="date-picker-div">
            {{ 'label.common.date-picker.to' | translate}}
            <p-calendar
              [(ngModel)]="endReception"
              [touchUI]="true"
              [readonlyInput]="true"
              dateFormat="{{returnDateFormat()}}"
              (onSelect)="onDateSelection()"
            ></p-calendar>
            <em *ngIf="endReception"
              (click)="endReception = null; onDateSelection();"
              (keyDown)="endReception = null; onDateSelection();"
              class="reset-icon fas fa-times"
            ></em>
          </div>
        </div>
      </div>
    </ng-container>


    <div fxLayout="row" fxLayoutAlign="start center" *ngIf="!singleSelectionMode">
      <advanced-sample-multiple-select fxFlex="100" #selectSample
        [multiSelectInput]="sampleSelection"
        bindLabel="label" (update)="onSelectionRefreshed($event)">
      </advanced-sample-multiple-select>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center" *ngIf="singleSelectionMode">
      <neq-select-autocomplete #select fxFlex="75" #selectSample
        [dataSource]="sampleSelection.fetchChoices"
        [multipleCheckBox]="false"
        [defaultLabel]="'label.common.sample' | translate"
        [bindLabel]="label"
        (change)="onSingleSampleSelectionChange($event)"
      >
      </neq-select-autocomplete>
      <div>{{ sampleSelection.nbTotal }} {{ sampleSelection.keyAfterTotal | translate }}</div>
    </div>

    <div class="asi-container" fxLayout="row" fxLayoutAlign="end center">
      <button pButton class="neq-primeng-button-text" label="{{ 'label.common.edition.cancel' | translate }}" (click)="onCancel()"></button>
      <button pButton class="neq-primeng-button-text" label="{{'label.common.edition.confirm' | translate}}" (click)="onSelectionSubmit()" *ngIf="!singleSelectionMode"></button>
    </div>
</div>
